









import { Component, Mixins } from "vue-property-decorator";

// Mixins
import ClientInjectorMixin from "@/mixins/clientInjectorMixin";

@Component({
  components: {
    "client-billing-settings": () =>
      import("@/components/app/admin/clients/clientBillingSettings.vue")
  }
})
export default class AdminClientSettingsBillingView extends Mixins(
  ClientInjectorMixin
) {}
